import React, { Component } from 'react'
import { ManageContent } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as manageContentActionCreators from '../../redux/modules/manageContent'
import { db } from '../../config/firebaseconfig'
import fetchItems from '../../helpers/fetchItems'
import saveContentItem from '../../helpers/saveContentItem'
import timestamper from '../../helpers/timestamper';
import getDefaultNewItem from '../../helpers/getDefaultNewItem'
import disarrayify from '../../helpers/disarrayify';
import arrayify from '../../helpers/arrayify';
const uuid = require('uuid/v1')

// Get all the items
// eventually, just paginate the items from the db!
// and only pull the fields needed

class ManageContentContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      itemName: '',
      itemCode: '',
      quillText: '',
    }


    this.handleClickItem = this.handleClickItem.bind(this)
    this.handleChangeActiveEditor = this.handleChangeActiveEditor.bind(this)
    this.handleDeleteAnswerChoice = this.handleDeleteAnswerChoice.bind(this)
    this.handleClickSave = this.handleClickSave.bind(this)
    this.handleAddAnswerChoice = this.handleAddAnswerChoice.bind(this)
    this.handleClickThumb = this.handleClickThumb.bind(this)
    this.handleInfoChange = this.handleInfoChange.bind(this)
    this.handleNewItemClick = this.handleNewItemClick.bind(this)
    this.handleItemDelete = this.handleItemDelete.bind(this)
    this.handleQuillChange = this.handleQuillChange.bind(this)
    this.handleChangeItemType = this.handleChangeItemType.bind(this)
  }

  componentDidMount() {    
    this.props.setIsFetching()
    this.unsubscribe = db.collection('contentItems').onSnapshot(
      (docs) => {
        let output = []
        docs.forEach( (doc) => {
          const data = doc.data()
          if (!data.deleted) {
            output.push(doc.data())
          }
        })
        this.props.fetchingSuccess(output)
      }, 
      (error) => this.props.fetchingError(error)
    )

    // Get nodes to use to tag the items
    this.props.fetchingNodes()
    let fetchedNodes = {}
    db.collection('knowledgeMapNodes').get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          const data = doc.data()
          fetchedNodes[data.id] = data
        })
        this.props.fetchingNodesSuccess(fetchedNodes)
      })
      .catch((err) => this.props.fetchingNodesError(err))
  }

  handleQuillChange(value) {
    this.setState({quillText: value})
  }

  handleChangeItemType(e) {
    const itemType = e.target.value
    this.props.setItemType(itemType)
    this.handleClickSave(e, itemType)
  }


  // ************* FIX!!!!!!!!!
  componentWillReceiveProps(nextProps) {
    if (this.props.activeItemId !== nextProps.activeItemId) {
      let newState = {}
      if (nextProps.activeItem.name) {
        newState.itemName = nextProps.activeItem.name
      } else {
        newState.itemName = ''
      }
      if (nextProps.activeItem.code) {
        newState.itemCode = nextProps.activeItem.code
      } else {
        newState.itemCode = ''
      }
      this.setState(newState)
    }
  }
  
  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  }

  handleClickItem (item) {
/*    let transformedAnswers = []
    for (var i = 0; i < Object.keys(item.answers).length ; i++) {
      const key = 'answer' + i 
      transformedAnswers.push(item.answers[key])
    } */
    const newItem = {
      ...item,
      answers: arrayify(item.answers),
    }
    if (newItem.passageId) {
      this.props.fetchingPassage()
      db.collection('contentItemPassages').doc(newItem.passageId).get()
        .then((doc) => {
          this.props.fetchingPassageSuccess()
          newItem.passage = doc.data().text
          this.props.selectActiveItem(newItem)
        })
        .catch((err) => {
          this.props.fetchingPassageError(err)
        })
    } else {
      this.props.selectActiveItem(newItem)
    }

  }

  closeOpenEditor() {
    if (this.props.activeItem.activeEdit.type === 'question') {
      const questionHTML = this.state.quillText
      this.props.setQuestion(questionHTML)
      return { question: questionHTML }
    } else if (this.props.activeItem.activeEdit.type === 'passage') {
      const passageHTML = this.state.quillText
      this.props.setPassage(passageHTML)
      return { passage: passageHTML }
    } else if (this.props.activeItem.activeEdit.type === 'answer' || this.props.activeItem.activeEdit.type === 'feedback') {
      let newAnswers = []
      for (var i = 0; i < this.props.activeItem.answers.length ; i++) {
        if (i === this.props.activeItem.activeEdit.index) {
          let newAnswer
          if (this.props.activeItem.activeEdit.type === 'answer') {
            newAnswer = {
              ...this.props.activeItem.answers[i],
              answer: this.state.quillText,
            }
          } else if (this.props.activeItem.activeEdit.type === 'feedback') {
            newAnswer = {
              ...this.props.activeItem.answers[i],
              feedback: this.state.quillText,
            }
          }
          newAnswers.push(newAnswer)
        } else {
          newAnswers.push(this.props.activeItem.answers[i])
        } 
      }
      this.props.activeItem.activeEdit.type ? this.props.setAnswers(newAnswers) : null
      return { answers: newAnswers }
    }
  }

  handleChangeActiveEditor (e, newActiveEditor) {
    this.closeOpenEditor()
    this.props.setActiveEdit(newActiveEditor)

    let newQuillText

    if (newActiveEditor.type === 'question') {
      newQuillText = this.props.activeItem.question
    } else if (newActiveEditor.type === 'answer' || newActiveEditor.type === 'feedback') {
      newQuillText = this.props.activeItem.answers[newActiveEditor.index][newActiveEditor.type]
    } else if (newActiveEditor.type === 'passage') {
      this.props.activeItem.passage
      ? newQuillText = this.props.activeItem.passage
      : newQuillText = ''
    }

    this.setState({
      quillText: newQuillText
    })
  }

  handleAddAnswerChoice(e) {
    let newAnswers = this.props.activeItem.answers.slice(0)
    newAnswers.push({
      correct: false,
      answer: 'Add a choice here',
      feedback: 'Explain why right or wrong',
    })
    this.props.setAnswers(newAnswers)
  }

  handleDeleteAnswerChoice(e, index) {
    let answers = this.props.activeItem.answers.slice(0)
    answers.splice(index, 1)
    this.props.setAnswers(answers)
  }

  handleClickSave(e, itemType) {
    const replacementContent = this.closeOpenEditor()
    this.props.setActiveEdit({type: '', index: 0})
    this.setState({
      quillText: '',
    })
    this.props.setIsSaving()
    const itemToSave = {
      itemId: this.props.activeItem.itemId,
      contentType: this.props.activeItem.contentType,
      itemType: itemType ? itemType : this.props.activeItem.itemType,
      shuffle: this.props.activeItem.shuffle,
      question: this.props.activeItem.question,
      answers: this.props.activeItem.answers,
      startingLetter: this.props.activeItem.startingLetter,
      nodeTags: this.props.activeItem.nodeTags,
      name: this.state.itemName,
      code: this.state.itemCode,
      passage: this.props.activeItem.passage ? this.props.activeItem.passage : '',
      passageId: this.props.activeItem.passageId ? this.props.activeItem.passageId : '',
      videoFeedback: this.props.activeItem.videoFeedback || '',
      videoFeedbackThumbnail: this.props.activeItem.videoFeedbackThumbnail || '',

    }
    if (replacementContent) {
      replacementContent.question ? itemToSave.question = replacementContent.question : null
      replacementContent.answers ? itemToSave.answers = replacementContent.answers : null
      replacementContent.passage ? itemToSave.passage = replacementContent.passage : null
    }

    saveContentItem(itemToSave)
      .then( () => {
        const date = new Date
        const timestamp = date.getTime()
        this.props.savingSuccess(timestamp)
      })
      .catch( (error) => {
        this.props.savingError(error)
      })
  }

  toggleModal(modalOpen) {
    this.props.toggleModal(modalOpen)
  }

  handleClickThumb(index, correctQ) {
    let newAnswer = this.props.activeItem.answers[index]
    newAnswer.correct = correctQ
    this.props.setAnswer(index, newAnswer)
  }

  handleInfoChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  handleNewItemClick() {
    this.props.addingNewItem()
    const newItem = getDefaultNewItem(uuid(), timestamper())
    const newItemForDb = {
      ...newItem,
      answers: disarrayify(newItem.answers, 'answer'),
    }
    db.collection('contentItems').doc(newItem.itemId).set(newItemForDb)
      .then(() => this.props.addingNewItemSuccess(newItem))
      .catch((err) => {
        console.log(err)
        this.props.addingNewItemError(err)})
  }

  handleItemDelete(itemId) {
    this.props.deletingItem()
    db.collection('contentItems').doc(itemId).set({deleted: true}, {merge:true})
      .then(() => this.props.deletingItemSuccess())
      .catch((err) => this.props.deletingItemError(err))
  }

  render() {
    return (
      <ManageContent
        contentType={this.props.contentType}
        setContentType={this.props.setContentType}
        activeItem={this.props.activeItem}
        toggleShuffle={this.props.setShuffle}
        items={this.props.items}
        isFetching={this.props.isFetching}
        handleClickItem={this.handleClickItem}
        activeItemId={this.props.activeItemId}
        handleChangeActiveEditor={this.handleChangeActiveEditor}
        handleDeleteAnswerChoice={this.handleDeleteAnswerChoice}
        handleClickSave={this.handleClickSave}
        handleAddAnswerChoice={this.handleAddAnswerChoice}
        handleClickThumb={this.handleClickThumb}
        startingLetter={this.props.activeItem.startingLetter}
        setStartingLetter={this.props.setStartingLetter}
        nodes={this.props.nodes}
        addNodeTag={this.props.addNodeTag}
        deleteNodeTag={this.props.deleteNodeTag}
        itemName={this.state.itemName}
        itemCode={this.state.itemCode}
        handleInfoChange={this.handleInfoChange}
        handleNewItemClick={this.handleNewItemClick}
        handleItemDelete={this.handleItemDelete}
        quillText={this.state.quillText}
        handleQuillChange={this.handleQuillChange}
        handleChangeItemType={this.handleChangeItemType}
        search={this.props.location.search}
        history={this.props.history}
      />
    )
  }
}

export default connect(
  (state) => ({
    contentType: state.manageContent.contentType,
    activeItem: state.manageContent.activeItem,
    items: state.manageContent.items,
    isFetching: state.manageContent.isFetching,
    activeItemId: state.manageContent.activeItemId,
    nodes: state.manageContent.nodes,
  }),
  (dispatch) => bindActionCreators(manageContentActionCreators, dispatch)
)(ManageContentContainer)

// pass in editorState, onEditorStateChange, setActiveEdit

/*
export default connect(
  (state) => ({
    itemId: state.createContent.itemId,
    contentType: state.createContent.contentType,
    itemType: state.createContent.itemType,
    shuffle: state.createContent.shuffle,
    question: state.createContent.question,
    answers: state.createContent.answers,
    activeEdit: state.createContent.activeEdit,
    isFetching: state.createContent.isFetching,
    isSaving: state.createContent.isSaving,
    error: state.createContent.error,
    lastSaved: state.createContent.lastSaved,
    noChanges: state.createContent.noChanges,
    modalOpen: state.createContent.modalOpen,
    modalMessage: state.createContent.modalMessage,

  }),
  (dispatch) => bindActionCreators(createContentActionCreators, dispatch)
)(CreateContentContainer)


*/


// WEBPACK FOOTER //
// ./src/containers/Content/ManageContentContainer.js